export default __webpack_public_path__ + "static/media/5g.69dc0eb6.svg";